import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/Calculator";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Admin from "@/pages/Admin";
import PoshanPanji from "@/pages/PoshanPanji";
import Laddoo from "@/pages/Laddoo";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Profile from "@/pages/Profile";
import Personalize from "@/pages/Personalize";
import Referrals from "@/pages/Referrals";
import Premium from "@/pages/Premium";
import Dashboard from "@/pages/Dashboard";
import DailyEntry from "@/pages/DailyEntry";
import DailyHistory from "@/pages/DailyHistory";
import Reports from "@/pages/Reports";
import MonthlyMDCF from "@/pages/MonthlyMDCF";
import { Terms, Privacy, Refund } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginReferralPopup, { shouldShowLoginReferralPopup, markLoginReferralPopupShown } from "@/components/LoginReferralPopup";
import { Analytics } from "@/lib/analytics";
import { api } from "@/lib/api";
import { useState } from "react";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    Analytics.pageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function LoginPopupHost() {
  const { justLoggedIn, clearJustLoggedIn } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!justLoggedIn) return;
    let cancelled = false;
    (async () => {
      // Read the campaign config so admins can disable the popup or tune the cooldown.
      const cfg = await api.campaignConfig().catch(() => null);
      if (cancelled) return;
      const popupEnabled = cfg ? !!cfg.popup_enabled : true;
      const cooldown = cfg?.popup_cooldown_hours ?? 24;
      if (popupEnabled && shouldShowLoginReferralPopup(cooldown)) {
        setOpen(true);
        markLoginReferralPopupShown();
      }
      clearJustLoggedIn();
    })();
    return () => { cancelled = true; };
  }, [justLoggedIn, clearJustLoggedIn]);
  return <LoginReferralPopup open={open} onClose={() => setOpen(false)}/>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouteTracker/>
          <LoginPopupHost/>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/laddoo" element={<Laddoo />} />
              <Route path="/poshan-panji" element={<PoshanPanji />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/personalize" element={<Personalize />} />
              <Route path="/referrals" element={<Referrals />} />
              <Route path="/premium" element={<Premium />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/daily-entry" element={<DailyEntry />} />
              <Route path="/daily-history" element={<DailyHistory />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/monthly-mdcf" element={<MonthlyMDCF />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/refund" element={<Refund />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
